var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",class:{ 'button--disabled': _vm.disabled },on:{"click":function($event){_vm.disabled ? null : _vm.$emit('click')}}},[_c('p',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }